import { APP_ROUTES, ACCESS_LEVEL } from "const";
import home from "assets/images/sidebar-home-1.svg";
import homeActive from "assets/images/sidebar-home-1-active.svg";
import building from "assets/images/sidebar-building-2.svg";
import buildingActive from "assets/images/sidebar-building-2-active.svg";
import user from "assets/images/sidebar-user-3.svg";
import userActive from "assets/images/sidebar-user-3-active.svg";
import money from "assets/images/sidebar-money-4.svg";
import moneyActive from "assets/images/sidebar-money-4-active.svg";
import teamwork from "assets/images/sidebar-teamwork-5.svg";
import teamworkActive from "assets/images/sidebar-teamwork-5-active.svg";
import mortarboard from "assets/images/sidebar-mortarboard-6.svg";
import mortarboardActive from "assets/images/sidebar-mortarboard-6-active.svg";
import museum from "assets/images/sidebar-museum-8.svg";
import museumActive from "assets/images/sidebar-museum-8-active.svg";
import globe from "assets/images/sidebar-globe-9.svg";
import globeActive from "assets/images/sidebar-globe-9-active.svg";
import customer from "assets/images/sidebar-customer-10.svg";
import customerActive from "assets/images/sidebar-customer-10-active.svg";
import consortiums from "assets/images/sidebar-consortiums_.svg";
import consortiumsActive from "assets/images/sidebar-consortiums-16-active.svg";
import profitReport from "assets/images/sidebar-profit-report-11.svg";
import profitReportActive from "assets/images/sidebar-profit-report-11-active.svg";
import share from "assets/images/sidebar-share-12.svg";
import shareActive from "assets/images/sidebar-share-12-active.svg";
import newspaper from "assets/images/sidebar-newspaper-13.svg";
import mediaMonitoring from "assets/images/mediaMonitoring.svg";
import mediaMonitoringActive from "assets/images/mediaMonitoringActive.svg";
import dashboardIcon from "assets/images/dashboard-icon.svg";
import dashboardIconActive from "assets/images/dashboard-icon-active.svg";
import spaceIcon from "assets/images/spaceIcon.svg";
import spaceIconActive from "assets/images/spaceIconActive.svg";
import launchIcon from "assets/images/launchIcon.svg";
import launchIconActive from "assets/images/launchIconActive.svg";
import scraperIcon from "assets/images/scraperIcon.svg";
import scraperIconActive from "assets/images/scraperIconActive.svg";
import scraperIntIcon from "assets/images/scraperIntIcon.svg";
import scraperIntIconActive from "assets/images/scraperIntIconActive.svg";
import marketMapIcon from "assets/images/map.svg";
import marketMapIconActive from "assets/images/map-active.svg";
import graphIcon from "assets/images/graph.svg";
import graphIconActive from "assets/images/graph-active.svg";
import graphingTool from "assets/images/graphing-tool.svg";
import graphingToolActive from "assets/images/graphing-active.svg";
import qcaas from "assets/images/qcaas_.svg";
import qcaasActive from "assets/images/qcaas-active.svg";
import map from "assets/images/map-icon.svg";
import mapActive from "assets/images/map-icon-active.svg";
import partnerships from "assets/images/sidebar-partnerships-20.svg";
import partnershipsActive from "assets/images/sidebar-partnerships-20-active.svg";
import useCases from "assets/images/useCases_.svg";
import useCasesActive from "assets/images/useCasesActive.svg";
import patents from "assets/images/patentsIcon.svg";
import patentsActive from "assets/images/patentsIconActive.svg";
import researchPapers from "assets/images/researchPapers.svg";
import researchPapersActive from "assets/images/researchPapersActive.svg";
import govOp from "assets/images/iconGovOp.svg";
import govOpActive from "assets/images/iconGovOpActive.svg";
import {
  MenuGroupDivider,
  MenuGroupHeader,
  NavigationItem,
} from "./components";
import config from "config";

export type NavGroup = {
  groupRole?: string;
  groupHeader: null | {
    component: any;
    props: { [key: string]: any };
  };
  paths: {
    to: APP_ROUTES;
    tabs?: APP_ROUTES[];
    children: JSX.Element;
    moduleName: string;
    role?: string;
  }[];
};

export const NAVIGATION_PATHS: NavGroup[] = [
  {
    groupHeader: null,
    paths: [
      {
        to: APP_ROUTES.DASHBOARD,
        children: (
          <NavigationItem
            icon={home}
            iconActive={homeActive}
            title="Dashboard"
          />
        ),
        moduleName: "DASHBOARD",
      },
    ],
  },
  {
    groupHeader: {
      component: MenuGroupHeader,
      props: {
        name: "Entities",
      },
    },
    paths: [
      {
        to: APP_ROUTES.COMPANIES,
        tabs: [
          APP_ROUTES.COMPANY_PROFILE,
          APP_ROUTES.COMPANY_FUNDING,
          APP_ROUTES.COMPANY_PATENTS,
          APP_ROUTES.COMPANY_CONTACTS,
          APP_ROUTES.COMPANY_FINANCIAL_DETAILS,
        ],
        children: (
          <NavigationItem
            icon={building}
            iconActive={buildingActive}
            title="Companies"
            dataTip={`Explore detailed information on ${config.PLATFORM_NAME} tech companies, including profiles, classifications, and key metrics.`}
          />
        ),
        moduleName: "COMPANIES",
      },
      {
        to: APP_ROUTES.INVESTORS,
        tabs: [APP_ROUTES.INVESTOR_PROFILE],
        children: (
          <NavigationItem
            icon={user}
            iconActive={userActive}
            title="Investors"
            dataTip={`Find investor profiles, funding history, and strategic insights on the major players in ${config.PLATFORM_NAME} tech investments.`}
          />
        ),
        moduleName: "INVESTORS",
      },
      {
        to: APP_ROUTES.UNIVERSITIES,
        tabs: [APP_ROUTES.UNIVERSITY_PROFILE],
        children: (
          <NavigationItem
            icon={mortarboard}
            iconActive={mortarboardActive}
            title="Universities"
            dataTip={`Access information on academic and research institutions driving ${config.PLATFORM_NAME} innovation worldwide.`}
          />
        ),
        moduleName: "UNIVERSITIES",
      },
      {
        to: APP_ROUTES.GROUPS_AND_CENTERS,
        tabs: [APP_ROUTES.GROUPS_AND_CENTERS_PROFILE],
        children: (
          <NavigationItem
            icon={teamwork}
            iconActive={teamworkActive}
            title="Groups and Centers"
            dataTip={`Discover ${config.PLATFORM_NAME} research groups and innovation centers pushing the boundaries of technology.`}
          />
        ),
        moduleName: "GROUPS_AND_CENTERS",
      },
      {
        to: APP_ROUTES.GOVERNMENTS,
        tabs: [APP_ROUTES.GOVERNMENT_ENTITIES_PROFILE],
        children: (
          <NavigationItem
            icon={museum}
            iconActive={museumActive}
            title="Government Entities"
            dataTip={`Discover government bodies, regulatory agencies, and public institutions driving ${config.PLATFORM_NAME} policy, funding, and innovation oversight.`}
          />
        ),
        moduleName: "GOVERNMENTS",
      },
      {
        to: APP_ROUTES.ENTERPRISE_USERS,
        tabs: [APP_ROUTES.ENTERPRISE_USERS_PROFILE],
        children: (
          <NavigationItem
            icon={customer}
            iconActive={customerActive}
            title="Enterprise Users"
            dataTip={`Explore enterprises leveraging ${config.PLATFORM_NAME} technologies.`}
          />
        ),
        moduleName: "BRANDS",
      },
    ],
  },
  {
    groupHeader: {
      component: MenuGroupHeader,
      props: {
        name: "Ecosystem",
      },
    },
    paths: [
      {
        to: APP_ROUTES.MARKET_MAP,
        children: (
          <NavigationItem
            icon={marketMapIcon}
            iconActive={marketMapIconActive}
            title="Market Map"
            dataTip={`Visualize the ${config.PLATFORM_NAME} tech market landscape, segmented by companies, technologies, and regions.`}
          />
        ),
        moduleName: "MARKET_MAP",
      },
      {
        to: APP_ROUTES.SUMMARY_MAP,
        tabs: [APP_ROUTES.HEATMAP],
        children: (
          <NavigationItem
            icon={map}
            iconActive={mapActive}
            title="Map View"
            // dataTip={``}
          />
        ),
        moduleName: "MAP_VIEW",
      },
      {
        to: APP_ROUTES.PARTNERSHIPS,
        children: (
          <NavigationItem
            icon={partnerships}
            iconActive={partnershipsActive}
            title="Partnerships"
            dataTip={`Find relevant ${config.PLATFORM_NAME} partnerships and associated information.`}
          />
        ),
        moduleName: "RECENT_PARTNERSHIPS",
      },
      {
        to: APP_ROUTES.CONSORTIUMS,
        children: (
          <NavigationItem
            icon={consortiums}
            iconActive={consortiumsActive}
            title="Consortia"
            dataTip={`A list of ${config.PLATFORM_NAME} related consortia.`}
          />
        ),
        moduleName: "CONSORTIUMS",
      },
      {
        to: APP_ROUTES.QUANTUM_CLOUD_QPU_BENCHMARKING,
        tabs: [
          APP_ROUTES.QUANTUM_CLOUD_PROVIDERS,
          APP_ROUTES.QUANTUM_CLOUD_TERMS,
          APP_ROUTES.QUANTUM_CLOUD_CONTACT,
        ],
        children: (
          <NavigationItem
            icon={qcaas}
            iconActive={qcaasActive}
            title="Quantum Processors"
            dataTip={`Community-driven data showcasing ${config.PLATFORM_NAME} metrics and ${config.PLATFORM_NAME} cloud providers.`}
          />
        ),
        moduleName: "QUANTUM_CLOUD",
      },
      {
        to: APP_ROUTES.USE_CASES,
        children: (
          <NavigationItem
            icon={useCases}
            iconActive={useCasesActive}
            title="Use Cases"
            dataTip={`Explore real-world applications and use cases of ${config.PLATFORM_NAME} technologies across industries.`}
          />
        ),
        moduleName: "USE_CASES",
      },
      {
        to: APP_ROUTES.GRAPH_EXPLORER,
        children: (
          <NavigationItem
            icon={graphIcon}
            iconActive={graphIconActive}
            title="Graph Explorer"
            dataTip={`Deep-dive into entity relationships.`}
          />
        ),
        moduleName: "GRAPH_EXPLORER",
      },
    ],
  },
  {
    groupHeader: {
      component: MenuGroupHeader,
      props: {
        name: "Funding",
      },
    },
    paths: [
      {
        to: APP_ROUTES.FUNDING_ROUNDS,
        children: (
          <NavigationItem
            icon={money}
            iconActive={moneyActive}
            title="Funding Rounds"
            dataTip={`Discover the latest private funding activities in ${config.PLATFORM_NAME} tech, including funding amounts, stages, and dates, to identify emerging trends and opportunities.`}
          />
        ),
        moduleName: "FUNDING_ROUNDS",
      },
      {
        to: APP_ROUTES.GOVERNMENT_FUNDINGS,
        children: (
          <NavigationItem
            icon={globe}
            iconActive={globeActive}
            title="Government Funding"
            dataTip={`View Government funding for ${config.PLATFORM_NAME} initiatives by country (USD).`}
          />
        ),
        moduleName: "GOVERNMENT_FUNDINGS",
      },
      {
        to: APP_ROUTES.GOVERNMENT_OPPORTUNITIES_US,
        children: (
          <NavigationItem
            icon={govOp}
            iconActive={govOpActive}
            title="Government Opportunities"
            dataTip={`Identify government opportunities for investment, partnerships, and technological advancements.`}
          />
        ),
        moduleName: "GOVERNMENT_OPPORTUNITIES",
      },
    ],
  },
  {
    groupHeader: {
      component: MenuGroupHeader,
      props: {
        name: "Media",
      },
    },
    paths: [
      {
        to: APP_ROUTES.SEARCH_ENGINE_HOME,
        tabs: [
          APP_ROUTES.SEARCH_ENGINE_STORIES,
          APP_ROUTES.SEARCH_ENGINE,
          APP_ROUTES.ANALYSIS_GRAPH,
        ],
        children: (
          <NavigationItem
            icon={newspaper}
            iconActive={newspaper}
            title="News Engine"
            dataTip={`Read the latest news about the ${config.PLATFORM_NAME} industry. `}
          />
        ),
        moduleName: "NEWS_ENGINE",
      },
      {
        to: APP_ROUTES.MEDIA_MONITORING,
        children: (
          <NavigationItem
            icon={mediaMonitoring}
            iconActive={mediaMonitoringActive}
            title="Media Monitoring"
          />
        ),
        moduleName: "MEDIA_MONITORING",
      },
    ],
  },
  {
    groupHeader: {
      component: MenuGroupHeader,
      props: {
        name: "Analysis",
      },
    },
    paths: [
      ...(process.env.REACT_APP_ENV !== "prod"
        ? [
          {
            to: APP_ROUTES.SATELLITE_MISSIONS,
            role: ACCESS_LEVEL.ADMIN,
            children: (
              <NavigationItem
                icon={spaceIcon}
                iconActive={spaceIconActive}
                title="Satellite Missions"
              />
            ),
            moduleName: "SATELLITE_MISSIONS",
          },
          {
            to: APP_ROUTES.LAUNCH_STATISTICS,
            role: ACCESS_LEVEL.ADMIN,
            children: (
              <NavigationItem
                icon={launchIcon}
                iconActive={launchIconActive}
                title="Launch Statistics"
              />
            ),
            moduleName: "LAUNCH_STATISTICS",
          }
        ] : []
      ),
      {
        to: APP_ROUTES.PATENTS,
        children: (
          <NavigationItem
            icon={patents}
            iconActive={patentsActive}
            title="Patents"
            dataTip={`View patent filings across the ${config.PLATFORM_NAME} ecosystem.`}
          />
        ),
        moduleName: "PATENTS",
      },
      {
        to: APP_ROUTES.RESEARCH_PAPERS,
        children: (
          <NavigationItem
            icon={researchPapers}
            iconActive={researchPapersActive}
            title="Research Papers"
            dataTip={`View research / academic papers across the ${config.PLATFORM_NAME} ecosystem.`}
          />
        ),
        moduleName: "RESEARCH_PAPERS",
      },
      {
        to: APP_ROUTES.GRAPHING_TOOL,
        tabs: [APP_ROUTES.GRAPHING_TOOL_ROUNDS, APP_ROUTES.ANALYSIS_TOOL],
        children: (
          <NavigationItem
            icon={graphingTool}
            iconActive={graphingToolActive}
            title="Visualisation"
            dataTip={`Deep-dive into ${config.PLATFORM_NAME} entity relationships.`}
          />
        ),
        moduleName: "VISUALISATION",
      },
      {
        to: APP_ROUTES.REPORTS,
        children: (
          <NavigationItem
            icon={profitReport}
            iconActive={profitReportActive}
            title="Reports"
            dataTip={`Access in-depth market reports and analyses on the ${config.PLATFORM_NAME} tech sector.`}
          />
        ),
        moduleName: "REPORTS",
      },
      {
        to: APP_ROUTES.TAXONOMY,
        children: (
          <NavigationItem
            icon={share}
            iconActive={shareActive}
            title="Taxonomy"
            dataTip={`Navigate through a structured taxonomy of ${config.PLATFORM_NAME} classifications and terms.`}
          />
        ),
        moduleName: "TAXONOMY",
      },
    ],
  },
  ...(process.env.REACT_APP_ENV !== "prod"
    ? [
        {
          groupHeader: {
            component: MenuGroupHeader,
            props: {
              name: "Scraper Dashboard",
              hideForNoAdmins: true,
            },
          },
          paths: [
            {
              to: APP_ROUTES.SCRAPER_DASHBOARD_COMPANY,
              tabs: [
                APP_ROUTES.SCRAPER_DASHBOARD_FUNDING,
                APP_ROUTES.SCRAPER_DASHBOARD_INVESTOR,
                APP_ROUTES.SCRAPER_DASHBOARD_PARTNERSHIP,
              ],
              role: ACCESS_LEVEL.ADMIN,
              children: (
                <NavigationItem
                  icon={scraperIcon}
                  iconActive={scraperIconActive}
                  title="Data Workflow"
                />
              ),
              moduleName: "ADMIN_DASHBOARD",
            },

            {
              to: APP_ROUTES.SCRAPER_DASHBOARD_COMPANY_INTEGRATED,
              tabs: [
                APP_ROUTES.SCRAPER_DASHBOARD_FUNDING_INTEGRATED,
                APP_ROUTES.SCRAPER_DASHBOARD_INVESTOR_INTEGRATED,
                APP_ROUTES.SCRAPER_DASHBOARD_PARTNERSHIP_INTEGRATED,
              ],
              role: ACCESS_LEVEL.ADMIN,
              children: (
                <NavigationItem
                  icon={scraperIntIcon}
                  iconActive={scraperIntIconActive}
                  title="Integration Status"
                />
              ),
              moduleName: "ADMIN_DASHBOARD",
            },
          ],
        },
      ]
    : []),
  {
    groupRole: ACCESS_LEVEL.ADMIN,
    groupHeader: {
      component: MenuGroupDivider,
      props: {},
    },
    paths: [
      {
        to: APP_ROUTES.ADMIN_DASHBOARD,
        tabs: [APP_ROUTES.MANAGE_ADMINS, APP_ROUTES.BULK_UPLOAD],
        role: ACCESS_LEVEL.ADMIN,
        children: (
          <NavigationItem
            icon={dashboardIcon}
            iconActive={dashboardIconActive}
            title="Admin Dashboard"
          />
        ),
        moduleName: "ADMIN_DASHBOARD",
      },
    ],
  },
];
